/* eslint-disable import/prefer-default-export */

export const PODCASTS_PAGINATION = 6;
export const MINIMUM_LETTER_QUANTITY = 3;
export const REJECTED_OFFER_DATE_FORMAT = 'MMM DD YYYY';
